import React from 'react';
import styled from 'styled-components';

export enum Alignments {
  Top = 'top',
  Bottom = 'bottom',
  Center = 'center'
}

const getAlignment = (alignment: string | undefined) => {
  switch (alignment) {
    case Alignments.Top:
      return 'start';
    case Alignments.Bottom:
      return 'end';
    case Alignments.Center:
    default:
      return 'center';
  }
};

const getFlexDirection = (layout: string | undefined, desktopReverse: boolean | undefined) => {
  if (layout === 'text-image-vertical') {
    return 'column-reverse';
  }
  if (layout === 'image-text-vertical') {
    return 'column';
  }
  return desktopReverse ? 'row-reverse' : 'row';
};

interface Props {
  children: React.ReactNode[];
  mobileReverse?: boolean;
  desktopReverse?: boolean;
  breakpoint?: string;
  justifyContent?: Alignments;
  alignment?: string;
  gap?: string;
  gapMobile?: string;
  layout?: string;
  equal?: boolean;
}

const TwoColumn: React.FC<Props> = ({
  children,
  layout,
  mobileReverse,
  desktopReverse,
  breakpoint,
  justifyContent,
  alignment,
  gap,
  gapMobile,
  equal
}) => (
  <Container
    className="two-column"
    $layout={layout}
    $mobileReverse={mobileReverse}
    $breakpoint={breakpoint}
    $justifyContent={justifyContent}
    $alignment={alignment}
    $gap={gap}
    $gapMobile={gapMobile}
    $desktopReverse={desktopReverse}
    $equal={equal}
  >
    {children[0]}
    {children[1]}
  </Container>
);

export default TwoColumn;

interface IContainer {
  $mobileReverse?: boolean;
  $desktopReverse?: boolean;
  $equal?: boolean;
  $breakpoint?: string;
  $justifyContent?: string;
  $alignment?: string;
  $gap?: string;
  $gapMobile?: string;
  $layout?: string;
}

const Container = styled.div<IContainer>`
  display: flex;
  flex-direction: ${(props) => getFlexDirection(props.$layout, props.$desktopReverse)};
  justify-content: ${(props) => getAlignment(props.$justifyContent)};
  align-items: ${(props) => getAlignment(props.$alignment)};
  gap: ${(props) => (props.$gap ? props.$gap : '0')};

  @media (max-width: ${(props) => (props.$breakpoint ? props.$breakpoint : '768px')}) {
    flex-direction: ${(props) => (props.$mobileReverse ? 'column-reverse' : 'column')};
    gap: ${(props) => (props.$gapMobile ? props.$gapMobile : '0')};
    max-width: 100%;
  }

  & > * {
    display: flex;
    flex-direction: column;
    ${(props) => (props.$equal ? 'flex: 1' : '')};
  }

  @media (min-width: 1440px) {
    justify-content: center;
  }
`;
